import React, { Component, Text, useState, useRef, useEffect, useContext } from 'react'
import { Navbar, NavbarBrand, Nav, NavItem, Row, NavbarToggler,ModalBody, Collapse, Col, Modal, FormGroup, Input, Button, FormFeedback, NavLinkReactor } from 'reactstrap';
import logo from '../../../Assets/slashlogo2purple.png'
import '../../../CSS/NavBarLatest.css'
import { NavLink } from 'react-router-dom';
import favouriteLogo from '../../../Assets/icon-favorite-border.png'
import cartLogo from '../../../Assets/mi-shopping-cart.png'
import wishlist_filled_icon from '../../../Assets/wishlist_filled_color_icon.png'
import cart_filled_icon from '../../../Assets/checkout_filled_color_icon.png'
import profile_filled_icon from '../../../Assets/profile_filled_color_icon.png'
import profileLogo from '../../../Assets/group-482319@2x.png'
import profileLogo1 from '../../../Assets/asicon-outline-user.png'
import favBlack from '../../../Assets/favBlck.png'
import shpCrtblk from '../../../Assets/shpCrtblk.png'
import picPro from '../../../Assets/picPro.png'
import { useLocation } from "react-router";
import slashTran from '../../../Assets/slashLogo1white.png'
import { globalState } from '../../../GlobalState/globalState';
import { ToastContainer, toast } from 'react-toastify';
import { authLogOut } from '../../../GlobalState/globalStateActions';
import { useNavigate } from 'react-router-dom';
import customFetchData from '../customFetchData';
import RegisstrAndLogin_India from '../../../Screens/RegisterrAndLogin_India';
import { mobileHeaderNav } from '../NavPaths';
import NavPaths from '../NavPaths';
import { useMediaQuery } from 'react-responsive';
import AppStoreIcon from '../../../../New_WebPage_Design/Assets/Commons/appstore 1.png'
import PlayStoreIcon from '../../../../New_WebPage_Design/Assets/Commons/googleplay 1.png'
import downloadAppPhnImage from '../../../Assets/downloadAppPhnImage.png'
import downloadAppPhnImageWeb from '../../../Assets/downloadAppPhnImageWeb.png'
import closeIcon from '../../../../New_Website_V2/Assets/icons-closeModal.png'
import { AiFillCloseCircle } from "react-icons/ai";

import redirectBannerCrossIcon from '../../../Assets/icons-closeModal.png'
export default function NavBarV2(props) {
    const navigate = useNavigate();
    let location = useLocation();
    let [state, dispatch] = useContext(globalState)
    const [country, setCoutry] = useState('India')
    const [stateColor, setStateColor] = useState()
    const [modal, setModal] = useState(false)
    const [pathnameLink, setPathnameLink] = useState('')
    const [showDownloadAppModal, setShowDownloadAppModal] = useState(false)
    const path = '/' + location.pathname.split('/')[1]
    const useMobileAndBelowMediaQuery = () => useMediaQuery({ query: "(max-width: 760px)" })
    const useTabletMediaQuery = () => useMediaQuery({ minWidth: 768, maxWidth: 991 })
    const isMobileView = useMobileAndBelowMediaQuery()
    const isTabView = useTabletMediaQuery()
   let [redirectBannerModal, setRedirectBannerModal] = useState(false)
    useEffect(() => {
        console.log('location.pathname', path)
        if (path == "/" || path == "/home" || path == "/at-home" || path == "/in-store") {

            setPathnameLink('home')

        } else if (path == "/blog") {

            setPathnameLink('blog')

        } else if (path == "/businesslisting") {

            setPathnameLink('professional')

        } else if (path == "/support") {

            setPathnameLink('help')

        } else if (path == "/offers") {

            setPathnameLink('offers')

        } else if (path == "/c/mybookings") {

            setPathnameLink('bookings')

        } else if (path == "/wishlist") {

            setPathnameLink('wishlist')

        } else if (path == "/checkout") {

            setPathnameLink('checkout')

        } else if (path == "/profile" || path == "/c/deleteAccount" || path == "/c/savedAddresses" || path == "/setting" || path == "/referandearn" || path == "/ConsumerEditProfile" || path == "/c/myTransactions") {

            setPathnameLink('profile')

        } else {
            console.log('path', path)
            // setPathnameLink('home')
            // navigate('/')

        }
        ///// dispatch
        dispatch({ type: "SET_SELECTED_SERVICE_TAB", selectedServiceTab:  path === '/in-store' ? "in_store" : "at_home"});

    }, [])
    useEffect(() => {
        !NavPaths.includes(path) ? setStateColor('') : setStateColor('transparent')
        window.scrollTo(0, 0);
    }, [location.pathname])
    function listenScrollEvent() {
        const backgroundcolor = (window.scrollY == 0 && NavPaths.includes(path)) ? "transparent" : "";
        setStateColor(backgroundcolor);
    }
    useEffect(() => {
        window.addEventListener('scroll', listenScrollEvent);
        return () =>
            window.removeEventListener('scroll', listenScrollEvent);
    }, [NavPaths.includes(path)]);
    const serviceSelectionHandler = (serviceType) => {
        dispatch({ type: "SET_SELECTED_SERVICE_TAB", selectedServiceTab: serviceType });
        setPathnameLink("home")
        // if(path === '/in-store' && serviceType === 'at_home' || path === '/at-home' && serviceType === 'in_store' || path === '/home' && serviceType === 'in_store' || path === '/home' && serviceType === 'at_home' || path == '/' || path == ''){
        // } else{
            navigate('/')
        // }
    }  
    
    const onPressDownloadApp=()=>{
      console.log('download app')
      setShowDownloadAppModal(true)
        setRedirectBannerModal(true)
    }
    let showDownloadAppModalView = (
        <Modal isOpen={showDownloadAppModal} toggle={() => setShowDownloadAppModal(false)} centered size="lg">
            <div className="download-app-modal-container">
                <div className="download-app-modal-left">
                    <span className="use_theapp_text">Use the app to finish booking your service</span>
                    <span className="download-app-modal-headline">Your go-to app<br />for everyday <br />services</span>
                    <span className="download-app-modal-subheadline">Download App to get started</span>
                    <div className="download-app-modal-buttons">
                        <a href="https://play.google.com/store/apps/details?id=com.quickfinduser&utm_campaign=Consumer_Guide&utm_source=Website&utm_medium=DigitalMarketingSources" target="_blank" rel="noopener noreferrer">
                        {/* <a href="https://play.google.com/store/apps/details?id=com.quickfindmerchant&utm_campaign=Merchant_Guide&utm_source=Website&utm_medium=DigitalMarketingSources" target="_blank" rel="noopener noreferrer"> */}
                            <img src={PlayStoreIcon} alt="Get it on Google Play" className="download-app-modal-store-icon" />
                        </a>
                        <a href="https://apps.apple.com/us/app/slash-consumer/id1489207325?ls=1/?utm_campaign=Consumer_Guide&utm_source=Website&utm_medium=DigitalMarketingSources" target="_blank" rel="noopener noreferrer">
                        {/* <a href="https://apps.apple.com/us/app/slash-merchant/id1489211413?ls=1/?utm_campaign=Merchant_Guide&utm_source=Website&utm_medium=DigitalMarketingSources" target="_blank" rel="noopener noreferrer"> */}
                            <img src={AppStoreIcon} alt="Download on the App Store" className="download-app-modal-store-icon" />
                        </a>
                    </div>
                </div>
                <div className="download-app-modal-right">
                    <img src={downloadAppPhnImageWeb} alt="Slash App on Phone" className="download-app-modal-phone-img" />
                    <div className="download-app-modal-bg-accent" onClick={() => setShowDownloadAppModal(false)}>
                        <AiFillCloseCircle size={30}/>
                        {/* <img src={closeIcon} alt="Close" onClick={() => setShowDownloadAppModal(false)} /> */}
                    </div>
                </div>
            </div>
            
        </Modal>
    )
    
    console.log('pathnameLink', location.pathname)
    return (
        <>
            <Navbar
                light
                expand="lg"
                className="navbar_main_new_sv2"
                style={{
                    backgroundColor: stateColor,
                    backgroundImage: stateColor === "transparent" ? null : "linear-gradient(to right, #222027, #222027, #2B1E45)",
                    boxShadow:
                        stateColor === "transparent"
                            ? null
                            : "0 4px 4px 0 rgba(0, 0, 0, 0.1)",
                    position: "fixed",
                    top: 0,
                    overflow: "hidden",
                    width: "100%",
                    zIndex: 1000,
                    // padding: "10px 129px",
                    // minHeight: 100,
                }}
            >
                <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ display: "flex", flexDirection: "row",alignItems: "center", gap: 20 }}>
                        <NavbarBrand
                            style={{display: "flex",}}
                            className='navbrand_responsive'
                        >
                            <NavLink
                                onClick={() => setPathnameLink("home")}
                                to="/"
                                style={{ display: "flex" }}
                            >
                                <img
                                    className='navbrand_image_resposive'
                                    src={stateColor === "#fff" ? logo : slashTran}
                                    alt="Slash Logo"
                                />
                            </NavLink>
                        </NavbarBrand>
                        {
                            // location.pathname == '/' || location.pathname == '/home' || location.pathname == '/at-home' || location.pathname == '/in-store' ? 
                            <>
                                <div
                                    onClick={() => serviceSelectionHandler("at_home")}
                                    className="selected_service_tab_style"
                                    style={{
                                        // height:36.5,
                                        color:
                                            stateColor !== "#fff"
                                                ? "#fff"
                                                : state.selectedServiceTab === "at_home"
                                                    ? "#8c52ff"
                                                    : "black",
                                        borderBottom:
                                            state.selectedServiceTab === "at_home"
                                                ? "2px solid #8c52ff"
                                                : "2px solid transparent",
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: 8,
                                        // background: "rgba(140,82,255,0.2)",
                                        padding: "8px 8px",
                                        transition: "color 0.2s, border-bottom 0.2s",
                                    }}>
                                    <text className='navText_responsive'>At Home</text>
                                </div>
                                <div
                                    onClick={() => serviceSelectionHandler("in_store")}
                                    className="selected_service_tab_style"
                                    style={{
                                        // height:36.5,
                                        color:
                                            stateColor !== "#fff"
                                                ? "#fff"
                                                : state.selectedServiceTab === "in_store"
                                                    ? "#8c52ff"
                                                    : "black",
                                        borderBottom:
                                            state.selectedServiceTab === "in_store"
                                                ? "2px solid #8c52ff"
                                                : "2px solid transparent",
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        // marginLeft: 28,
                                        borderRadius: 8,
                                        // background: "rgba(140,82,255,0.2)",
                                        padding: "8px 8px",
                                        transition: "color 0.2s, border-bottom 0.2s",
                                    }}>
                                    <text className='navText_responsive'>In Store</text>
                                </div>
                            </>
                            // :
                            // null
                        }
                    </div>
                    <div
                        style={{
                            // marginRight: "5%",
                            // marginTop: 28,
                            flex: 1,
                            display: "flex",
                            justifyContent: "flex-end",
                        }}
                        className="beforeLogin_div me-auto"
                    >
                        <Nav navbar style={{ flexDirection: "row", alignItems: "center", gap: 25 }}>
                            <NavItem>
                                <NavLink
                                    onClick={() => setPathnameLink("blog")}
                                    className={
                                        pathnameLink === "blog"
                                            ? "blog_navlink_active"
                                            : "blog_navlink"
                                    }
                                    style={{
                                        color:
                                            stateColor !== "#fff"
                                                ? "#fff"
                                                : pathnameLink === "blog"
                                                    ? "#8c52ff"
                                                    : "black",
                                        borderBottom:
                                            pathnameLink === "blog"
                                                ? "2px solid #8c52ff"
                                                : "2px solid transparent",
                                        // fontSize: 16,
                                        // marginLeft: 28,
                                        // fontFamily: "Inter",
                                        // textDecoration: "none",
                                        // fontWeight: 600,
                                        borderRadius: 8,
                                        // background: "rgba(140,82,255,0.2)",
                                        padding: "8px 8px",
                                        transition: "color 0.2s, border-bottom 0.2s",
                                    }}
                                    to="/blog"
                                >
                                    Blog
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    onClick={() => setPathnameLink("professional")}
                                    className={
                                        pathnameLink === "professional"
                                            ? "Are_you_pro_navlink_active"
                                            : "Are_you_pro_navlink"
                                    }
                                    style={{
                                        color:
                                            stateColor !== "#fff"
                                                ? "#fff"
                                                : pathnameLink === "professional"
                                                    ? "#8c52ff"
                                                    : "black",
                                        borderBottom:
                                            pathnameLink === "professional"
                                                ? "2px solid #8c52ff"
                                                : "2px solid transparent",
                                        // fontSize: 16,
                                        // fontFamily: "Inter",
                                        // textDecoration: "none",
                                        // fontWeight: 600,
                                        borderRadius: 8,
                                        // background: "rgba(140,82,255,0.2)",
                                        padding: "8px 8px",
                                        transition: "color 0.2s, border-bottom 0.2s",
                                    }}
                                    to="/businesslisting"
                                >
                                    Are you a professional?
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    onClick={() => setPathnameLink("help")}
                                    className={
                                        pathnameLink === "help"
                                            ? "offers_navlink_active"
                                            : "offers_navlink"
                                    }
                                    style={{
                                        color:
                                            stateColor !== "#fff"
                                                ? "#fff"
                                                : pathnameLink === "help"
                                                    ? "#8c52ff"
                                                    : "black",
                                        borderBottom:
                                            pathnameLink === "help"
                                                ? "2px solid #8c52ff"
                                                : "2px solid transparent",
                                        // fontSize: 16,
                                        // fontFamily: "Inter",
                                        // textDecoration: "none",
                                        // fontWeight: 600,
                                        borderRadius: 8,
                                        // background: "rgba(140,82,255,0.2)",
                                        padding: "8px 8px",
                                        transition: "color 0.2s, border-bottom 0.2s",
                                    }}
                                    to="/support"
                                >
                                    Help
                                </NavLink>
                            </NavItem>

                            <NavItem>
                                <NavLink style={{textDecoration:'none'}} onClick={() => onPressDownloadApp()}>
                                    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start', padding: '12px 10px', borderRadius: '10px', backgroundColor:'#fff'}}>  
                                        <text className='navText_responsive' style={{display:'flex', justifyContent:'center',alignItems:'center',color:'#000'}}>Download our APP NOW!</text>
                                    </div>
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </div>
                </div>
                {/* {
                    showDownloadAppModal && showDownloadAppModalView 
                } */}
            </Navbar>



   <Modal isOpen={redirectBannerModal} style={{borderRadius:25}} size='lg'>
        <ModalBody style={{borderRadius:25}}>
          <div style={{position:'absolute', right:32, top:20}} className='crossIcon_ViewPro' onClick={() => {setRedirectBannerModal(false)}}>
            {/* <img src={redirectBannerCrossIcon} style={{}}/> */}
            <AiFillCloseCircle size={30}/>
          </div>
                    <div style={{ width: '100%', height: '100%', borderRadius: 25 }}>
                        {pathnameLink === "professional" ?
                            <img src={'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1781689065239-lg.png'} style={{ width: '100%', height: '100%', borderRadius: 25 }} />
                            :
                            <img src={'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1781688480606-lg.png'} style={{ width: '100%', height: '100%' }} />
                        }
                    </div> 
        </ModalBody>
      </Modal>
        </>
    )
}

